import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Link from "@mui/material/Link/Link";
import Stack from "@mui/material/Stack/Stack";
import { useFormik } from "formik";
import Box from "@mui/material/Box/Box";
import Button from "@mui/material/Button/Button";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import { Autocomplete, Chip, Grid, styled } from "@mui/material";

import PlayCircleOutlineOutlined from "@mui/icons-material/PlayCircleOutlineOutlined";
import AddProjectValidation from "../../validation/addProjectValidation";
import CancelIcon from "@mui/icons-material/Cancel";
import firebase from "../../firebase/firebase";
import { useContext } from "react";
import { AuthUserContext } from "../../providers/AuthProvider";
import Spinner from "../../components/spinner";
import { useNavigate, useParams } from "react-router-dom";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import moment from "moment";
import ScrollToTop from "../../utils/scrollTop";
import PostActivity from "../../helpers/post-activity";
import preTags from "../../utils/tags";
import {SelectChangeEvent} from "@mui/material/Select/Select";

const storageRef = firebase.storage().ref();
function AddProject({ parentcallback }) {
	const { user, profile } = useContext(AuthUserContext);
	const [projectImage, setProjectImage] = React.useState();
	const [genre, setGenre] = React.useState([]);
	const [projectCoverImage, setProjectCoverImage] = React.useState();
	const [projectTrailer, setProjectTrailer] = React.useState();
	const [loading, setLoading] = React.useState(true);
	const navigator = useNavigate();
	const Input = styled("input")({
		display: "none",
	});
	let { projectId } = useParams();
	const [edit, setEdit] = React.useState(!projectId);

	const [initialValues, setInitialValues] = React.useState(
		AddProjectValidation.initialValues
	);
	const handleChange = (event: SelectChangeEvent<typeof genre>) => {
		const {
			target: { value },
		} = event;
		setGenre(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	const [mediaFilesValue, setMediaFilesValues] = React.useState();
	const uploadFile = (folder, title) => {
		return new Promise((resolve, reject) => {
			const file =
				folder === "image"
					? projectImage.file
					: folder === "cover"
					? projectCoverImage.file
					: projectTrailer.file;
			const path = `profiles/${profile.uid}/portfolio/${title}/${folder}/${file.name}`;
			const uploadTask = storageRef.child(path).put(file);

			// Register three observers:
			// 1. 'state_changed' observer, called any time the state changes
			// 2. Error observer, called on failure
			// 3. Completion observer, called on successful completion
			uploadTask.on(
				"state_changed",
				(snapshot) => {
					// Observe state change events such as progress, pause, and resume
					// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
					var progress =
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					console.log("Upload is " + progress + "% done");
					switch (snapshot.state) {
						case firebase.storage.TaskState.PAUSED: // or 'paused'
							console.log("Upload is paused");
							break;
						case firebase.storage.TaskState.RUNNING: // or 'running'
							console.log("Upload is running");
							break;
					}
				},
				(error) => {
					reject(error);

					// Handle unsuccessful uploads
				},
				() => {
					// Handle successful uploads on complete
					// For instance, get the download URL: https://firebasestorage.googleapis.com/...
					resolve(path);
				}
			);
		});
	};
	const uploadFileEdit = (folder, title, file) => {
		return new Promise((resolve, reject) => {
			const path = `profiles/${profile.uid}/portfolio/${title}/${folder}/${file.name}`;
			const uploadTask = storageRef.child(path).put(file);

			// Register three observers:
			// 1. 'state_changed' observer, called any time the state changes
			// 2. Error observer, called on failure
			// 3. Completion observer, called on successful completion
			uploadTask.on(
				"state_changed",
				(snapshot) => {
					// Observe state change events such as progress, pause, and resume
					// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
					var progress =
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					console.log("Upload is " + progress + "% done");
					switch (snapshot.state) {
						case firebase.storage.TaskState.PAUSED: // or 'paused'
							console.log("Upload is paused");
							break;
						case firebase.storage.TaskState.RUNNING: // or 'running'
							console.log("Upload is running");
							break;
					}
				},
				(error) => {
					reject(error);

					// Handle unsuccessful uploads
				},
				() => {
					// Handle successful uploads on complete
					// For instance, get the download URL: https://firebasestorage.googleapis.com/...
					resolve(path);
				}
			);
		});
	};
	const formik = useFormik({
		initialValues: AddProjectValidation.initialValues,
		validationSchema: AddProjectValidation.addProjectSchema,
		onSubmit: async (values) => {
			try {
				setLoading(true);
				const image = await uploadFile("image", values.title);
				const cover = await uploadFile("cover", values.title);
				const trailer = await uploadFile("trailer", values.title);
				const projectRef = firebase
					.firestore()
					.collection("users")
					.doc(profile.id);
				const getProfile = await projectRef.get();
				if (getProfile.data() && getProfile.data().portfolio) {
					const portfolios = getProfile.data().portfolio;
					portfolios.push({
						...values,
						genre,
						mediaFiles: {
							image,
							cover,
							trailer,
						},

						uid: user.uid,
					});
					await projectRef.update({
						portfolio: portfolios,
					});
				} else {
					await projectRef.update({
						portfolio: [
							{
								...values,
								genre,
								mediaFiles: {
									image,
									cover,
									trailer,
								},
							},
						],
					});
				}
				PostActivity({
					text: `You edited your portfolio.`,
					uid: profile.uid,
					createdBy:profile?.uid
				}).then()
				setLoading(false);
				parentcallback(false);
				// setTimeout(() => alert('Successfully add project'), 500)
			} catch (e) {
				setLoading(false);
				alert(e);
			}
		},
	});
	const downloadURL = (url) =>
		new Promise((resolve, reject) => {
			const mediaRef = storageRef.child(url);

			// Get the download URL
			mediaRef
				.getDownloadURL()
				.then((url) => {
					resolve(url);
					// setImageUrl(url)
					// setLoading(false)
					// Insert url into an <img> tag to "download"
				})
				.catch((error) => {
					reject(error);
					// setLoading(false)

					// A full list of error codes is available at
					// https://firebase.google.com/docs/storage/web/handle-errors
					switch (error.code) {
						case "storage/object-not-found":
							// File doesn't exist
							break;
						case "storage/unauthorized":
							// User doesn't have permission to access the object
							break;
						case "storage/canceled":
							// User canceled the upload
							break;

						// ...

						case "storage/unknown":
							// Unknown error occurred, inspect the server response
							break;
					}
				});
		});
	React.useEffect(() => {
		if (projectId) {
			const projectRef = firebase
				.firestore()
				.collection("projects")
				.doc(projectId);
			projectRef
				.get()
				.then(async (snapshot) => {
					setLoading(false);
					setMediaFilesValues(snapshot.data().mediaFiles);
					formik.setValues({
						...snapshot.data(),
					});
					if (snapshot.data().mediaFiles) {
						if (snapshot.data().mediaFiles.cover) {
							const cover = await downloadURL(
								snapshot.data().mediaFiles.cover
							);
							setProjectCoverImage({ src: cover });
						}
						if (snapshot.data().mediaFiles.image) {
							const image = await downloadURL(
								snapshot.data().mediaFiles.image
							);
							setProjectImage({ src: image });
						}
						if (snapshot.data().mediaFiles.trailer) {
							const mediaRef = storageRef.child(
								snapshot.data().mediaFiles.trailer
							);
							const metadata = await mediaRef.getMetadata();
							const trailer = await downloadURL(
								snapshot.data().mediaFiles.trailer
							);
							setProjectTrailer({
								src: trailer,
								size: (metadata?.size / 1024 / 1024).toFixed(2),
							});
						}
					}
				})
				.catch((err) => setLoading(false));
		} else setLoading(false);
	}, []);
	if (loading) return <Spinner />;
	return (
		<React.Fragment>
			<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}

			<Container
				maxWidth="fullWidth"
				sx={{ backgroundColor: "#E3E8F0", paddingY: 3, marginY: 0 }}>
				<Container maxWidth="md" sx={{ textAlign: "left" }}>
					<Typography
						variant={"h4"}
						color={"primary"}
						sx={{ marginY: 5 }}>
						Add project to portfolio
					</Typography>
				</Container>
			</Container>
			<Container maxWidth="md" sx={{ textAlign: "left", pb: 5 }}>
				<Stack
					direction="row"
					spacing={5}
					sx={{ width: "90%", mb: 1.5, mt: 6 }}>
					<Typography
						variant={"h6"}
						color={"primary"}
						sx={{ flex: 1 }}>
						<b>
							{projectId && formik?.values?.title !== ""
								? formik?.values?.title
								: ""}
						</b>
					</Typography>
					{projectId && (
						<Button
							variant={"contained"}
							size={"small"}
							sx={{ pr: 2, pl: 2 }}
							onClick={() => setEdit(!edit)}
							startIcon={<ModeEditOutlineOutlinedIcon />}>
							Edit project
						</Button>
					)}
				</Stack>
				<Stack direction="row" spacing={5}>
					<Stack
						direction={"column"}
						alignItems="center"
						spacing={2}
						sx={{ width: "250px" }}>
						{projectImage && projectImage.src ? (
							<>
								<Button
									sx={{ py: 1 }}
									onClick={() => {
										setProjectImage({
											src: "",
											file: "",
										});
									}}>
									Remove picture
								</Button>
								<Box
									sx={{
										width: 255,
										height: 333,
										backgroundColor:
											edit && projectId ? "#000" : "none",
										borderRadius: "14px",
									}}>
									<img
										src={projectImage.src}
										style={{
											width: 255,
											height: 333,
											borderRadius: "14px",
											position: "relative",
											top: 0,
											right: 0,
											opacity:
												edit && projectId ? 0.5 : 1,
											objectFit: "cover",
										}}
										alt=""
									/>
									{projectId && edit && (
										<label htmlFor="project-image-edit">
											<Input
												accept="image/*"
												id="project-image-edit"
												multiple={false}
												type="file"
												onChange={(e) => {
													const fileReader =
														new FileReader();
													fileReader.readAsDataURL(
														e.target.files[0]
													);
													fileReader.addEventListener(
														"load",
														async function () {
															setProjectImage({
																src: this
																	.result,
																file: e.target
																	.files[0],
																size: (
																	e.target
																		.files[0]
																		?.size /
																	1024 /
																	1024
																).toFixed(2),
															});
															if (projectId) {
																const image =
																	await uploadFileEdit(
																		"image",
																		formik
																			.values
																			.title,
																		e.target
																			.files[0]
																	);
																const projectRef =
																	firebase
																		.firestore()
																		.collection(
																			"projects"
																		)
																		.doc(
																			projectId
																		);
																await projectRef.update(
																	{
																		mediaFiles:
																			{
																				...mediaFilesValue,
																				image,
																			},
																	}
																);
																setMediaFilesValues(
																	{
																		...mediaFilesValue,
																		image,
																	}
																);
															}
														}
													);
												}}
											/>
											<Button
												sx={{
													position: "relative",
													top: "-55%",
													right: " -18%",
													color: " #ffffffa6",
													fontWeight: 600,
												}}
												component="span">
												change project image
											</Button>
										</label>
									)}
								</Box>
							</>
						) : (
							<>
								<Box
									sx={{
										width: 255,
										height: 333,
										border: "2.5px dashed rgba(0, 0, 0, 0.23)",
										borderRadius: "14px",
									}}>
									{/*<label htmlFor="project-image">*/}
									<label htmlFor="project-image">
										<Stack
											direction="column"
											justifyContent="center"
											alignItems="center"
											spacing={1}
											sx={{ height: 333 }}>
											<Input
												accept="image/*"
												id="project-image"
												multiple={false}
												type="file"
												onChange={(e) => {
													const fileReader =
														new FileReader();
													fileReader.readAsDataURL(
														e.target.files[0]
													);
													fileReader.addEventListener(
														"load",
														function () {
															setProjectImage({
																src: this
																	.result,
																file: e.target
																	.files[0],
															});
														}
													);
												}}
											/>

											<Button
												component="span"
												fullWidth
												color={"secondary"}
												sx={{ height: 314 }}
												startIcon={
													<img
														src="/assets/upload-icon.png"
														style={{
															width: 42,
															height: 42,
														}}
														alt=""
													/>
												}
											/>
										</Stack>
									</label>

									{/*</label>*/}
								</Box>
							</>
						)}
					</Stack>
					<Stack
						direction={"column"}
						sx={{ flex: 1, pr: 15 }}
						spacing={2}>
						{projectCoverImage && projectCoverImage.src ? (
							<>
								<Button
									onClick={() => {
										setProjectCoverImage({
											src: "",
											file: "",
										});
									}}>
									Remove Cover
								</Button>
								<Box
									sx={{
										width: "100%",
										height: 115,
										backgroundColor:
											edit && projectId ? "#000" : "none",
										borderRadius: "14px",
									}}>
									<img
										src={projectCoverImage.src}
										style={{
											width: "100%",
											height: 115,
											borderRadius: "14px",
											position: "relative",
											objectFit: "cover",
											top: 0,
											right: 0,
											opacity:
												edit && projectId ? 0.5 : 1,
										}}
										alt=""
									/>
									{projectId && edit && (
										<label htmlFor="project-cover-edit">
											<Input
												accept="image/*"
												id="project-cover-edit"
												multiple={false}
												type="file"
												onChange={(e) => {
													const fileReader =
														new FileReader();
													fileReader.readAsDataURL(
														e.target.files[0]
													);
													fileReader.addEventListener(
														"load",
														async function () {
															setProjectCoverImage(
																{
																	src: this
																		.result,
																	file: e
																		.target
																		.files[0],
																}
															);
															if (projectId) {
																const cover =
																	await uploadFileEdit(
																		"cover",
																		formik
																			.values
																			.title,
																		e.target
																			.files[0]
																	);
																const projectRef =
																	firebase
																		.firestore()
																		.collection(
																			"projects"
																		)
																		.doc(
																			projectId
																		);
																await projectRef.update(
																	{
																		mediaFiles:
																			{
																				...mediaFilesValue,
																				cover,
																			},
																	}
																);
																setMediaFilesValues(
																	{
																		...mediaFilesValue,
																		cover,
																	}
																);
															}
														}
													);
												}}
											/>
											<Button
												sx={{
													position: "relative",
													top: "-70%",
													right: " -40%",
													color: " #ffffffa6",
													fontWeight: 600,
												}}
												component="span">
												change cover image
											</Button>
										</label>
									)}
								</Box>
							</>
						) : (
							<label htmlFor={"project-cover-image"}>
								<Stack
									direction={"row"}
									justifyContent="center"
									alignItems="center"
									spacing={1}
									sx={{
										width: "100%",
										height: 115,
										border: "2.5px dashed rgba(0, 0, 0, 0.23)",
										borderRadius: "14px",
									}}>
									<Input
										accept="image/*"
										id="project-cover-image"
										multiple={false}
										type="file"
										onChange={(e) => {
											const fileReader = new FileReader();
											fileReader.readAsDataURL(
												e.target.files[0]
											);
											fileReader.addEventListener(
												"load",
												function () {
													setProjectCoverImage({
														src: this.result,
														file: e.target.files[0],
													});
												}
											);
										}}
									/>

									<Button
										component="span"
										fullWidth
										color={"secondary"}
										startIcon={
											<img
												src="/assets/upload-icon.png"
												style={{
													width: 36,
													height: 36,
													marginRight: 15,
												}}
												alt=""
											/>
										}>
										<>Upload Project cover </>
									</Button>
								</Stack>
							</label>
						)}

						<Stack
							direction={"row"}
							justifyContent="start"
							alignItems="start"
							spacing={1}
							sx={{ width: "100%" }}>
							{projectTrailer && projectTrailer.src ? (
								<Stack direction={"column"}>
									<Button
										onClick={() => {
											setProjectTrailer({
												src: "",
												file: "",
											});
										}}>
										Remove trailer
									</Button>
									<video
										src={projectTrailer.src}
										controls
										style={{
											width: 550,
											height: 180,
											borderRadius: "14px",
											objectFit: "contain",
											backgroundColor: "whitesmoke",
										}}
									/>
								</Stack>
							) : (
								<label htmlFor="project-trailer">
									<Stack
										direction={"column"}
										justifyContent="center"
										alignItems="center"
										spacing={1}
										sx={{
											width: 550,
											height: 180,
											border: "2.5px dashed rgba(0, 0, 0, 0.23)",
											borderRadius: "14px",
										}}>
										<Input
											accept="video/mp4,video/x-m4v,video/*"
											id="project-trailer"
											multiple={false}
											type="file"
											onChange={(e) => {
												const fileReader =
													new FileReader();
												// console.log(
												// 	"Size: ",
												// 	(
												// 		e.target.files[0].size /
												// 		1024 /
												// 		1024
												// 	).toFixed(4)
												// );
												/*
												 * Limitation: Max file size: 600MB
												 * */
												if (
													(
														e.target.files[0].size /
														1024 /
														1024
													).toFixed(4) > 600
												)
													return alert(
														"Max file size: 600MB"
													);

												fileReader.readAsDataURL(
													e.target.files[0]
												);
												fileReader.addEventListener(
													"load",
													async function () {
														setProjectTrailer({
															src: this.result,
															file: e.target
																.files[0],
														});
														if (projectId) {
															const trailer =
																await uploadFileEdit(
																	"trailer",
																	formik
																		.values
																		.title,
																	e.target
																		.files[0]
																);
															const projectRef =
																firebase
																	.firestore()
																	.collection(
																		"projects"
																	)
																	.doc(
																		projectId
																	);
															await projectRef.update(
																{
																	mediaFiles:
																		{
																			...mediaFilesValue,
																			trailer,
																		},
																}
															);
															setMediaFilesValues(
																{
																	...mediaFilesValue,
																	trailer,
																}
															);
														}
													}
												);
											}}
										/>

										<Button
											component={"span"}
											fullWidth
											sx={{
												flex: 0.95,
												color: "#c4c4c4",
											}}
											startIcon={
												<PlayCircleOutlineOutlined
													style={{
														width: 48,
														height: 48,
													}}
												/>
											}></Button>
									</Stack>
								</label>
							)}
						</Stack>
					</Stack>
				</Stack>
				<Stack
					direction={"column"}
					justifyContent="start"
					alignItems="start"
					spacing={3}
					sx={{ width: "100%", mt: 5 }}
					component={"form"}
					onSubmit={formik.handleSubmit}>
					{edit ? (
						<>
							<TextField
								fullWidth
								label={"Project Title*"}
								size={"medium"}
								value={formik.values.title}
								onChange={formik.handleChange}
								error={
									formik.touched.title &&
									Boolean(formik.errors.title)
								}
								helperText={
									formik.touched.title && formik.errors.title
								}
								name="title"
							/>
							<TextField
								fullWidth
								multiline
                                rows={4}
								label={"Description*"}
								size={"medium"}
								value={formik.values.description}
								onChange={formik.handleChange}
								error={
									formik.touched.description &&
									Boolean(formik.errors.description)
								}
								helperText={
									formik.touched.description &&
									formik.errors.description
								}
								name="description"
								// InputProps={{maxLength:500}}
							/>
							{/* <Typography style={{marginLeft:"91%",marginTop:"-3px"}} sx={{color:"#818488"}}>{500-formik.values.description.length}/500</Typography> */}
						
							<TextField
								fullWidth
								label={"Select Project Type*"}
								size={"medium"}
								select
								value={formik.values.type}
								onChange={formik.handleChange}
								error={
									formik.touched.type &&
									Boolean(formik.errors.type)
								}
								helperText={
									formik.touched.type && formik.errors.type
								}
								name="type">
								<MenuItem value={"Post Production"}>Post Production</MenuItem>
								<MenuItem value={"Pre Production"}>Pre Production</MenuItem>
								<MenuItem value={"Production Completed"}>Production Completed</MenuItem>
							</TextField>
							<Stack
								direction={"row"}
								justifyContent="start"
								alignItems="start"
								spacing={3}
								sx={{ width: "100%" }}>
								<TextField
									fullWidth
									label={"Production Start Date"}
									size={"medium"}
									type={"date"}
									InputLabelProps={{
										shrink: true,
									}}

									inputProps={{
										max: "2050-01-01",
										min: "2020-01-01",
									}}
									value={formik.values.startDate}
									onChange={formik.handleChange}
									error={
										formik.touched.startDate &&
										Boolean(formik.errors.startDate)
									}
									helperText={
										formik.touched.startDate &&
										formik.errors.startDate
									}
									name="startDate"
								/>
								<TextField
									fullWidth
									label={"Production End Date"}
									size={"medium"}
									type={"date"}
									value={formik.values.endDate}
									InputLabelProps={{
										shrink: true,
									}}
									inputProps={{
										max: "2050-01-01",
										min: "2020-01-01",
									}}
									onChange={formik.handleChange}
									error={
										formik.touched.endDate &&
										Boolean(formik.errors.endDate)
									}
									helperText={
										formik.touched.endDate &&
										formik.errors.endDate
									}
									name="endDate"
								/>
							</Stack>
							 {/* <TextField
								fullWidth
								label={"Genre*"}
								size={"medium"}
								select
								value={formik.values.genre}
								onChange={formik.handleChange}
								error={
									formik.touched.genre &&
									Boolean(formik.errors.genre)
								}
								helperText={
									formik.touched.genre && formik.errors.genre
								}
								name="genre">
								<MenuItem value={"test"}>Genre Type</MenuItem>
							</TextField> */}
							<TextField
								fullWidth
								label={"Your role"}
								size={"medium"}
								type={"text"}
								value={formik.values.role}
								onChange={formik.handleChange}
								error={
									formik.touched.role &&
									Boolean(formik.errors.role)
								}
								helperText={
									formik.touched.role &&
									formik.errors.role
								}
								name="role"
							/>
							<TextField
								label={"Genre"}
								fullWidth
								name="genre"
								required
								// value={formik.values.genre}
								// onChange={formik.handleChange}
								error={
									formik.touched.genre &&
									Boolean(formik.errors.genre)
								}
								helperText={
									formik.touched.genre && formik.errors.genre
								}
								sx={{ textAlign: "left" }}
								select
								SelectProps={{
									multiple: true,
									value: genre,
									onChange: handleChange,
								}}
								>
								{preTags.map((t) => (
									<MenuItem value={t}>{t}</MenuItem>
								))}
								</TextField>
								{genre.length > 0 && (
								<Grid container  spacing={2} >
									{genre.length > 0 &&
										genre.map((d) => (
											<Chip  xs={2}
												label={d}
												variant="contained"
												sx={{
													backgroundColor: "#E3E8F0",
													marginLeft:"5px",
													marginRight:"5px",
													marginBottom:"10px"
												}}
												onDelete={() =>
													setGenre(
														genre.filter(
															(f) => f !== d
														)
													)
												}
											/>
										))}
								</Grid>
							)}
							<TextField
								fullWidth
								label={"Language*"}
								size={"medium"}
								value={formik.values.language}
								onChange={formik.handleChange}
								error={
									formik.touched.language &&
									Boolean(formik.errors.language)
								}
								helperText={
									formik.touched.language &&
									formik.errors.language
								}
								name="language"
							/>
							<TextField
								fullWidth
								label={"Production Locations*"}
								size={"medium"}
								value={formik.values.location}
								onChange={formik.handleChange}
								error={
									formik.touched.location &&
									Boolean(formik.errors.location)
								}
								helperText={
									formik.touched.location &&
									formik.errors.location
								}
								name="location"
							/>
							<TextField
							multiline
                                rows={4}
								fullWidth
								// InputProps={{maxLength:500}}
								label={"Synopsis"}
								size={"medium"}
								value={formik.values.synopsis}
								onChange={formik.handleChange}
								error={
									formik.touched.synopsis &&
									Boolean(formik.errors.synopsis)
								}
								helperText={
									formik.touched.synopsis &&
									formik.errors.synopsis
								}
								name="synopsis"
							/>
							{/* <Typography style={{marginLeft:"91%",marginTop:"-3px"}} sx={{color:"#818488"}}>{500-formik.values.synopsis.length}/500</Typography> */}
						
							<TextField
								fullWidth
								label={"Website"}
								size={"medium"}
								value={formik.values.website}
								onChange={formik.handleChange}
								error={
									formik.touched.website &&
									Boolean(formik.errors.website)
								}
								helperText={
									formik.touched.website &&
									formik.errors.website
								}
								name="website"
							/>
							<TextField
								fullWidth
								label={"IMDB"}
								size={"medium"}
								value={formik.values.imdb}
								onChange={formik.handleChange}
								error={
									formik.touched.imdb &&
									Boolean(formik.errors.imdb)
								}
								helperText={
									formik.touched.imdb && formik.errors.imdb
								}
								name="imdb"
							/>
							<TextField
								fullWidth
								label={"Vimeo"}
								size={"medium"}
								value={formik.values.vimeo}
								onChange={formik.handleChange}
								error={
									formik.touched.vimeo &&
									Boolean(formik.errors.vimeo)
								}
								helperText={
									formik.touched.vimeo && formik.errors.vimeo
								}
								name="vimeo"
							/>
							<TextField
								fullWidth
								label={"Facebook"}
								size={"medium"}
								value={formik.values.facebook}
								onChange={formik.handleChange}
								error={
									formik.touched.facebook &&
									Boolean(formik.errors.facebook)
								}
								helperText={
									formik.touched.facebook &&
									formik.errors.facebook
								}
								name="facebook"
							/>
							<TextField
								fullWidth
								label={"Instagram"}
								size={"medium"}
								value={formik.values.instagram}
								onChange={formik.handleChange}
								error={
									formik.touched.instagram &&
									Boolean(formik.errors.instagram)
								}
								helperText={
									formik.touched.instagram &&
									formik.errors.instagram
								}
								name="instagram"
							/>
							{/*
                BUTTON BOTTOM
                */}
							<Stack
								spacing={2}
								direction="row"
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									width: "100%",
								}}>
								<Button
									sx={{
										pt: 1.2,
										pb: 1.2,
										pl: 5,
										pr: 5,
										textDecoration: "underline",
									}}
									onClick={() => parentcallback(false)}>
									Quit without saving
								</Button>

								<Button
									variant="contained"
									sx={{
										pt: 1.2,
										pb: 1.2,
										pl: 5,
										pr: 5,
										backgroundColor: "#FD4A01",
									}}
									color={"warning"}
									type={"submit"}>
								Save Changes
								</Button>
							</Stack>
						</>
					) : (
						""
					)}
				</Stack>
			</Container>
		</React.Fragment>
	);
}
export default AddProject;
